import { render, staticRenderFns } from "./PriceResult.vue?vue&type=template&id=a4f9823e&scoped=true&"
import script from "./PriceResult.vue?vue&type=script&lang=js&"
export * from "./PriceResult.vue?vue&type=script&lang=js&"
import style0 from "./PriceResult.vue?vue&type=style&index=0&id=a4f9823e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4f9823e",
  null
  
)

export default component.exports